import { deleteDocumentV2 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function deleteDocument(id: number): Promise<void> {
  await deleteDocumentV2(id)
}
